export default "__VITE_ASSET__562489f2__"